import React from 'react';
import * as S from '../styles';

export function DataLabelRight({ title, label, status, statusId }) {
  return <S.ColLabelDataRigth statusid={statusId}>
      <S.TitleData>{title}</S.TitleData>
      <S.LabelData statusLabel={status}>
        <S.LabelData statusLabel={status}>{label}</S.LabelData>
      </S.LabelData>
         </S.ColLabelDataRigth>;
}
